import { api } from '../../core/network/api';

export type DistrictOwner = 'you' | 'rival' | 'neutral';

/** Never seen a single cell of this ground — total fog. No name, no art, nothing. */
export interface UnknownDistrict {
  districtId: string;
  visibility: 'unknown';
}

/** Scouted (walked near it on the City Map) — basic intel only, no income figures. */
export interface SeenDistrict {
  districtId: string;
  visibility: 'seen';
  name: string;
  family: string;
  tier: number;
  unlockLevel: number;
  locked: boolean;
  owner: 'rival' | 'neutral';
  defense: number;
  /** Hex-tile distance from the hero to this hold's stronghold (null if unknown). */
  tilesAway: number | null;
}

/** You run this ground — full operational detail. */
export interface OwnedDistrict {
  districtId: string;
  visibility: 'owned';
  name: string;
  family: string;
  tier: number;
  unlockLevel: number;
  locked: false;
  owner: 'you';
  level: number;
  /** Tribute roof (6). Sent so the card can read "Lv 4/6" — a bare level was
   *  read as the ward's TIER, which is a different number (QA 86cb8zkcq). */
  levelMax: number;
  racket: string;
  income: number;
  defense: number;
  pendingIncome: number;
  storageCap: number;
  readyToCollect: boolean;
  /** When the first whole coin lands, ISO — so a greyed-out Collect can say how
   *  long it stays greyed out (QA 86cb8zjzx). Null when there is no clock to
   *  run (never collected, or a ground that earns nothing). */
  collectableAt: string | null;
  atStorageCap: boolean;
  upgradeCost: number | null;
  maxLevel: boolean;
  /** Raiders at the gate — collect/upgrade are locked until the siege breaks. */
  underSiege: boolean;
  siegeEndsAt: string | null;
  /** When the next raid lands on a safe ward — null while a siege is open. */
  nextSiegeAt: string | null;
  /** Hex-tile distance from the hero to this hold's stronghold (null if unknown). */
  tilesAway: number | null;
}

export type District = UnknownDistrict | SeenDistrict | OwnedDistrict;

export interface CollectResult { collected: number; cash: number; districtId: string }

export interface UpgradeResult {
  districtId: string;
  level: number;
  racket: string;
  income: number;
  defense: number;
  spent: number;
  cash: number;
  upgradeCost: number | null;
  maxLevel: boolean;
}

export const fetchDistricts = () =>
  api.get<{ districts: District[] }>('/territories').then((r) => r.districts);

export const collectDistrict = (districtId: string) =>
  api.post<CollectResult>(`/territories/${districtId}/collect`, {});

export const upgradeDistrict = (districtId: string) =>
  api.post<UpgradeResult>(`/territories/${districtId}/upgrade`, {});
